import { RelativeWallInfoItem } from '@/editor/data/wall/Wall';
import { IWallInfo } from '@/editor/types/wallShape';
import { HandleType } from '../wallShape/calculateHelper';

/**
 * 端盖求解器需要向「墙缓存」问的两件事。由 CalculateHelper 实现并传给同目录的各求解器模块，
 * 使这些求解器不必持有整份缓存、也不必是类的方法。
 */
export interface IWallLookup {
  /** 墙的真实建立顺序(来自 _wallInfos 下标)；未登记的视作最晚建立，用于「先绘制切后绘制」。 */
  orderOf(id: string): number;
  /** 把相连列表里的 id 解析成缓存中的墙信息；取不到的跳过(不会得到缺字段的假 IWallInfo)。 */
  resolve(list: { id: string }[]): IWallInfo[];
}

/** 本端「端点-端点相连」的相连墙原始列表。 */
export function connectToPointOf(wallInfo: IWallInfo, type: HandleType): RelativeWallInfoItem[] {
  const rel = wallInfo.relativeWallInfos;
  return (type === HandleType.Start ? rel?.mainStartConnectToPoint : rel?.mainEndConnectToPoint) || [];
}

/**
 * 本端「端点落在其 body 内部」的相连墙原始列表：落在中线上的，并上埋在实心带内的。
 * 落在中线上必然也埋在带内，故两类必有交集，这里的按 id 去重是必需的——重复会让下游「相连隔墙≥2」的计数虚高。
 */
export function onWallOf(wallInfo: IWallInfo, type: HandleType): RelativeWallInfoItem[] {
  const rel = wallInfo.relativeWallInfos;
  const onCenterline = (type === HandleType.Start ? rel?.mainStartOnWallInternal : rel?.mainEndOnWallInternal) || [];
  const inBody = (type === HandleType.Start ? rel?.mainStartInWallBody : rel?.mainEndInWallBody) || [];
  if (!inBody.length) return onCenterline;
  const seen = new Set(onCenterline.map((w) => w.id));
  return [...onCenterline, ...inBody.filter((w) => !seen.has(w.id))];
}

/** 某条墙两端点相连的全部墙(用于沿边界折线展开一跳邻边)。 */
export function neighborsOf(wallInfo: IWallInfo): RelativeWallInfoItem[] {
  const rel = wallInfo.relativeWallInfos;
  return [...(rel?.mainStartConnectToPoint || []), ...(rel?.mainEndConnectToPoint || [])];
}
